import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { CropSizeList } from './CropSizeList';
import { InputNumber, Slider } from '@tencent/glue-react-ui';
import { useRefCallback } from '@tencent/glue-react-use';
import { usePrefixCls } from '../../../config/hooks/usePrefixCls';
export var DisabledInputNumber = function DisabledInputNumber(_ref) {
  var className = _ref.className,
    value = _ref.value;
  return React.createElement("span", {
    className: className
  }, value);
};
export var CropControl = function CropControl(props) {
  var _props$fileName = props.fileName,
    fileName = _props$fileName === void 0 ? '' : _props$fileName,
    naturalSize = props.naturalSize,
    zoom = props.zoom,
    value = props.value,
    datasource = props.datasource,
    cropSize = props.cropSize,
    onCropSizeChange = props.onCropSizeChange,
    onValueChange = props.onValueChange,
    onZoomChange = props.onZoomChange,
    _props$style = props.style,
    style = _props$style === void 0 ? {
      width: 240,
      margin: '0 0 0 40px'
    } : _props$style;
  var cls = usePrefixCls('crop-control');
  var cropSizeChange = useRefCallback(function (val) {
    onCropSizeChange(_objectSpread(_objectSpread({}, cropSize), val));
  });
  var cropWidth = cropSize.minWidth === cropSize.maxWidth ? React.createElement(DisabledInputNumber, {
    className: "".concat(cls, "-disabled-input-number"),
    value: cropSize.width
  }) : React.createElement(InputNumber, {
    min: cropSize.minWidth || 1,
    max: cropSize.maxWidth,
    value: cropSize.width,
    onValueChange: function onValueChange(val) {
      return cropSizeChange({
        width: val
      });
    }
  });
  var cropHeight = cropSize.minHeight === cropSize.maxHeight ? React.createElement(DisabledInputNumber, {
    className: "".concat(cls, "-disabled-input-number"),
    value: cropSize.height
  }) : React.createElement(InputNumber, {
    min: cropSize.minHeight || 1,
    max: cropSize.maxHeight,
    value: cropSize.height,
    onValueChange: function onValueChange(val) {
      return cropSizeChange({
        height: val
      });
    }
  });
  return React.createElement("div", {
    className: cls,
    style: style
  }, React.createElement("p", {
    className: "".concat(cls, "-title ").concat(cls, "-title-first")
  }, "\u56FE\u7247\u4FE1\u606F"), React.createElement("p", {
    className: "".concat(cls, "-desc")
  }, React.createElement("span", {
    className: "".concat(cls, "-desc-label")
  }, "\u6587\u4EF6\u540D:"), React.createElement("span", {
    className: "".concat(cls, "-desc-value")
  }, fileName)), React.createElement("p", {
    className: "".concat(cls, "-desc")
  }, React.createElement("span", {
    className: "".concat(cls, "-desc-label")
  }, "\u539F\u56FE\u5C3A\u5BF8:"), React.createElement("span", {
    className: "".concat(cls, "-desc-value")
  }, naturalSize)), React.createElement("p", {
    className: "".concat(cls, "-title")
  }, "\u88C1\u526A\u5C3A\u5BF8"), datasource && datasource.length > 1 && React.createElement(CropSizeList, {
    style: {
      margin: '16px 0'
    },
    datasource: datasource,
    value: value,
    onValueChange: onValueChange
  }), React.createElement("div", {
    className: "".concat(cls, "-crop-size")
  }, React.createElement("div", {
    className: "".concat(cls, "-crop-size-width")
  }, "\u5BBD\uFF1A", cropWidth), React.createElement("div", {
    className: "".concat(cls, "-crop-size-height")
  }, "\u9AD8\uFF1A", cropHeight)), React.createElement("p", {
    className: "".concat(cls, "-title")
  }, "\u539F\u56FE\u7F29\u653E"), React.createElement("div", {
    className: "".concat(cls, "-zoom")
  }, "\u7F29\u5C0F", React.createElement(Slider, {
    className: "".concat(cls, "-zoom-slider"),
    min: zoom.min,
    max: zoom.max,
    value: zoom.value,
    onValueChange: function onValueChange(val) {
      return onZoomChange === null || onZoomChange === void 0 ? void 0 : onZoomChange(_objectSpread(_objectSpread({}, zoom), {}, {
        value: val
      }));
    }
  }), "\u653E\u5927"));
};